<template>
  <div>
    <div
      v-for="(group, gIndex) in advancedFilters"
      :key="'advanced-'+gIndex"
    >
      <Badge
        v-if="gIndex>0"
        class="or-badge"
      >
        OR
      </Badge>
      <div
        class="preview-group-wrapper"
        @click="$emit('openFilters')"
      >
        <div
          v-for="(filter, fIndex) in group"
          :key="'filter-'+gIndex+'-'+fIndex"
        >
          <Badge
            v-if="fIndex>0"
          >
            AND
          </Badge>
          <div>
            <span>{{initialText}}</span>
            <span class="filter-name">{{filter.name}}</span>
            <span>{{filter.operator}}</span>
            <span class="filter-value">{{filter.firstValue}}</span>
            <span>{{filter.condition}}</span>
            <span
              v-if="filter.extraValues"
            >
              <span class="filter-value">
              +{{filter.extraValues}}
              </span>
              &nbsp;others
            </span>
            <span
              v-else
              class="filter-value"
            >
              {{filter.secondValue}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Badge } from '@mikmak/components';

export default {
  props: {
    initialText: {
      type: String,
    },
    advancedFilters: {
      type: Array,
    },
  },
  components: {
    Badge,
  },
};
</script>
<style lang="scss" scoped>
.preview-group-wrapper {
  padding: 12px;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #C1CCD4;
  box-sizing: border-box;
  border-radius: 4px;
}
::v-deep .badge-wrapper {
  margin: 8px 0 !important;
  padding: 0;
  border: none !important;

  & button.primary {
      justify-content: center;
      width: 43px;
      background: #DBE4EB !important;
      border: none !important;
      border-radius: 100px;
      margin: 0px;
      padding: 2px 8px;
      font-family: Lato;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 140%;
      color: #223448;
      cursor: inherit;

      &:hover,
      &:focus {
        background: #DBE4EB !important;
      }
      &:active {
        background: #DBE4EB !important;
      }
  }
}

::v-deep .or-badge button.primary {
  margin-left: 14px !important;
}
.filter-name {
  color: #4369F4;
  font-weight: bold;
}
.filter-value {
  color: #B545AA;
  font-weight: bold;
}
</style>
